<div class="serchResults">
  <div class="searchResultsPresent">
    <div>
      <a (click)="redirectToHelpCenter()" class="help-link">
        <img src="" target="_blank" class="linkText" />
        Help Center
      </a>
    </div>
    <div *ngIf="searchResult && searchResult.products.length > 0">
      <h3 class="resultsText">
        Showing results for:
        <span class="textBold">{{ searchResult.freeTextSearch }}</span>
      </h3>
      <br />
    </div>

    <div *ngIf="searchResult && searchResult.products.length == 0">
      <h3 class="resultsText">
        Showing no results for:
        <span class="textBold">{{ searchResult.freeTextSearch }}</span>
      </h3>
    </div>
  </div>
</div>
